module.exports = __webpack_public_path__ + "images/pen-nib-light.svg";